import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

if (document.querySelector('.quote-slider')) {
    const swiper = new Swiper('.quote-slider .swiper', {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        loop: true,
        effect: 'fade',
        speed: 700,
        spaceBetween: 0,
        slidesPerView: 1,

        autoplay: {
            delay: 8500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: '.quote-slider .swiper-pagination',
            type: 'custom',
            renderCustom: (swiper, current, total) => {
                return `<span class="swiper-pagination-current">0${current}</span>/<span>0${total}</span>`;
            },
        },
        navigation: {
            nextEl: '.swiper-next-btn',
            prevEl: '.swiper-prev-btn',
        },
    });
}
